import React, { FC, useState } from "react";
import { Modal } from "react-bootstrap";
import MyIcon from "../Common/MyIcon";
import InfoIcon from "../../assets/icons/Icon_Library/application icons/general/movable.svg2";
import DetailsForSolutionModals from "./DetailsForSolutionModals";
import { SolutionCard } from "../Library/SolutionsCardList";
import { SolutionType } from "../store/slices/settingsSlice";

interface SolutionInfoModalProps {
  uuid?: string;
  solution: SolutionType;
}

const SolutionInfoModal: FC<SolutionInfoModalProps> = ({ uuid, solution }) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <div onClick={() => setShow(true)} className="h-100">
        <SolutionCard solution={solution} />
      </div>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center svg-white">
              <MyIcon Icon={InfoIcon} width={30} />
              <span className="ms-3 fs-3 fw-bold">Solution Information</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailsForSolutionModals solution={solution} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SolutionInfoModal;
